export default function getNavIcon(filename: string) {
  return new URL(`../assets/nav-icons/${filename}.webp`, import.meta.url).href;
}
